import React from "react";
import { useCompare } from "properties/propertyCard/components/favorite/compare-provider";
import { useTranslation } from "react-i18next";
import { Square, SquareCheck } from "lucide-react";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { PROPERTY_TYPE } from "properties/_models/PropertyMdl";

interface Props {
    itemId: string;
    type: PROPERTY_TYPE;
}

export const CompareButton = ({ itemId, type }: Props) => {
    const { t } = useTranslation();
    const { toggleCompare, isAlreadyCompared } = useCompare();

    return (
        <div
            className={
                "border border-[#1A3A45] rounded-full px-2 flex items-center justify-center cursor-pointer bg-white"
            }
            onClick={() => toggleCompare({ itemId: itemId, resource: COMMON_RESOURCE.PROPERTIES, type })}
        >
            {isAlreadyCompared(itemId) ? (
                <SquareCheck size={15} className="text-[#1A3A45]" />
            ) : (
                <Square size={15} className="text-[#1A3A45]" />
            )}
            <div className="ml-1 text-md">{t("propertiesPage.compare")}</div>
        </div>
    );
};
